module.exports = __webpack_public_path__ + "img/9.f89c3132.jpg";